import { Box, Avatar, Button, Typography } from "@mui/material";
import { useState } from "react";
import { assertImagesUrl } from "../../../redux/common";

interface AvatarUploadDragAndDropProps {
    value: string;
    onChange: (img: string) => void;
    alt: string;
}

const AvatarUploadDragAndDrop = ({ value, onChange, alt }: AvatarUploadDragAndDropProps) => {
    const [avatarPreview, setAvatarPreview] = useState<string>(value || "");
    const [dragOver, setDragOver] = useState(false);

    const handleFileChange = (file: File) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result && typeof reader.result === "string") {
                setAvatarPreview(reader.result);
                onChange(reader.result);
            }
        };
        reader.readAsDataURL(file);
    };

    const handleDrag = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setDragOver(event.type === "dragover");
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDragOver(false);
        const files = event.dataTransfer.files;
        if (files && files[0]) {
            handleFileChange(files[0]);
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            handleFileChange(event.target.files[0]);
        }
    };

    return (
        <Box
            sx={{
                border: dragOver ? "2px dashed #1976d2" : "2px dashed #ccc",
                borderRadius: 2,
                p: 2,
                textAlign: "center",
                cursor: "pointer",
                background: dragOver ? "#f0f7ff" : "inherit"
            }}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
        >
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 2 }}>
                <Avatar
                    src={assertImagesUrl(avatarPreview)}
                    alt={alt}
                    sx={{ width: 80, height: 80, border: "1px solid #ccc", mr: 2 }}
                />
                <label htmlFor="routine-item-avatar-upload">
                    <Button variant="contained" component="span" sx={{ mt: 0 }}>
                        Selecionar imagem
                    </Button>
                </label>
            </Box>
            <input
                accept="image/*"
                style={{ display: "none" }}
                id="routine-item-avatar-upload"
                type="file"
                onChange={handleInputChange}
            />
            <Typography variant="body2" sx={{ mt: 2 }}>
                Arraste uma imagem para esta área ou clique para selecionar.
            </Typography>
        </Box>
    );
};

export default AvatarUploadDragAndDrop;
